import { render, staticRenderFns } from "./newIndexBanner.vue?vue&type=template&id=2ac7e504&scoped=true&"
import script from "./newIndexBanner.vue?vue&type=script&lang=js&"
export * from "./newIndexBanner.vue?vue&type=script&lang=js&"
import style0 from "./newIndexBanner.vue?vue&type=style&index=0&id=2ac7e504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac7e504",
  null
  
)

export default component.exports